import { useState } from 'react'
import { useCanAccess } from '../hooks/useCanAccess'
import ClientManagement from '../components/client/ClientManagement'
import SiteManagement from '../components/admin/SiteManagement'
import UserManagement from '../components/admin/UserManagement'
import BadgeManagement from '../components/admin/BadgeManagement'
import '../styles/admin.css'

const TABS = [
  { id: 'clients', label: 'Clients' },
  { id: 'sites', label: 'Sites' },
  { id: 'users', label: 'Utilisateurs' },
  { id: 'badges', label: 'Badges' },
] as const

type TabId = (typeof TABS)[number]['id']

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState<TabId>('clients')
  const canAccess = useCanAccess('clients', 'read')

  if (!canAccess) {
    return <div className="admin-denied">Acces refuse</div>
  }

  return (
    <div className="admin-page">
      <div className="admin-page__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`admin-page__tab ${activeTab === tab.id ? 'admin-page__tab--active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="admin-page__content">
        {activeTab === 'clients' && <ClientManagement />}
        {activeTab === 'sites' && <SiteManagement />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'badges' && <BadgeManagement />}
      </div>
    </div>
  )
}
